import { QueryObserverResult, useQuery } from '@tanstack/react-query';
import { APIClient } from 'api/APIClient';
import { AllNotificationsEmailResults } from 'api/types/types';
import { QueryKeys } from 'constants/queryKeys';

async function getAllNotificationsEmail(
  dateFrom: string,
  dateTo: string,
  emailShortName?: string | undefined,
  searchText?: string | undefined,
  reference?: string | undefined
): Promise<AllNotificationsEmailResults> {
  const ref = reference ? `&reference=${reference}` : '';
  const templateShortName = emailShortName
    ? `&templateShortName=${emailShortName}`
    : '';
  const email = searchText ? `&email=${searchText}` : '';

  // const query = ref || templateShortName || email ? '?' : '';
  // ${query}
  const baseUrl = `/email?dateFrom=${dateFrom}&dateTo=${dateTo}${ref}${templateShortName}${email}`;

  const { data } = await APIClient().get(baseUrl);
  return data;
}

export function useGetAllNotificationEmailQuery(
  dateFrom: string,
  dateTo: string,
  emailShortName?: string | undefined,
  searchText?: string,
  reference?: string | undefined
): QueryObserverResult<AllNotificationsEmailResults, unknown> {
  return useQuery({
    queryKey: [
      QueryKeys.ALL_NOTIFICATIONS_EMAIL,
      dateFrom,
      dateTo,
      emailShortName,
      searchText,
      reference,
    ],
    queryFn: () =>
      getAllNotificationsEmail(
        dateFrom,
        dateTo,
        emailShortName,
        searchText,
        reference
      ),
    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
    meta: {
      errorMessage:
        'Ekki tókst að sækja yfirlit tilkynningarpósta. Reyndu aftur síðar',
    },
  });
}
